
import React, {FC} from 'react';
import classNames from 'classnames';
import {ChatText} from 'components/Assistant/ChatText';

import * as styles from './styles.module.scss';

type ChatPendingProps = {
	className?: string
	scroll?: boolean
	variant?: 'green' | 'white'
}

export const ChatPending: FC<ChatPendingProps> = ({
	className,
	scroll,
	variant = 'green',
}) => (
	<ChatText source='ASSISTANT' scroll={scroll} className={classNames({
		[className || '']: className,
		[styles.green]: variant === 'green',
		[styles.white]: variant === 'white',
	})}>
		<div className={styles.wrapper}>
			<div />
			<div />
			<div />
		</div>
	</ChatText>
);
